export class TemplateMultiLineInspectionInput {
    description = '';
    constructor(MultiLineInspection) {
        if (MultiLineInspection) {
            this.description = MultiLineInspection.description;
        }
    }
}
